import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { addSubtask } from "~/store/actions/actions.subtasks.jsx";
import { getTaskById } from "~/store/selectors/selector.tasks.jsx";
import SubtaskForm from "./SubtaskForm.jsx";

const AddSubtaskFormContainer = ({ projectId, taskId, visible, handleCancel }) => {
  const { t } = useTranslation();
  const submitText = t("Add");
  const dispatch = useDispatch();
  const task = useSelector((state) => getTaskById(state, taskId));
  const onSubmit = useCallback(
    (attributes) => {
      dispatch(addSubtask(projectId, taskId, attributes));
    },
    [dispatch, projectId, taskId]
  );
  if (!visible) return null;
  return (
    <SubtaskForm
      onSubmit={onSubmit}
      handleCancel={handleCancel}
      projectId={projectId}
      submitText={submitText}
      hiddenFromClient={task.get("is_hidden_from_clients")}
      taskDueOn={task?.get("due_on")}
      isCompleted={task.get("is_completed")}
    />
  );
};

AddSubtaskFormContainer.propTypes = {
  visible: PropTypes.bool,
  handleCancel: PropTypes.func,
  taskId: PropTypes.number,
  projectId: PropTypes.number,
};

AddSubtaskFormContainer.defaultProps = {
  visible: false,
  taskId: 0,
  projectId: 0,
};

AddSubtaskFormContainer.displayName = "AddSubtaskFormContainer";

export default AddSubtaskFormContainer;
